export const CANCEL_PERSON_ADDRESS_EDIT_STATE = "cancelPersonAddressEditState";
export const DELETE_ADDRESS = "deleteAddress";
export const FETCH_PERSON_ADDRESS = "fetchPersonAddress";
export const SAVE_ADDRESS = "saveAddress";
export const SAVE_PERSON_ADDRESS = "savePersonAddress";
export const UPDATE_ADDRESS = "updateAddress";
